import type { ProviderSpecialty } from '../../types';

export interface MockProvider {
  name: string;
  initials: string;
  specialty: ProviderSpecialty;
  title: string;
}

export const MOCK_PROVIDERS: MockProvider[] = [
  { name: 'Dr. Sarah Chen, MD', initials: 'SC', specialty: 'PCP', title: 'Internal Medicine' },
  { name: 'Dr. Raj Patel, MD', initials: 'RP', specialty: 'Cardiology', title: 'Cardiology' },
  { name: 'Dr. Lisa Kim, MD', initials: 'LK', specialty: 'Endocrinology', title: 'Endocrinology' },
  { name: 'Dr. James Park, MD', initials: 'JP', specialty: 'Nephrology', title: 'Nephrology' },
  { name: 'Dr. Maria Santos, MD', initials: 'MS', specialty: 'Pulmonology', title: 'Pulmonology' },
];
